module.exports = __webpack_public_path__ + "static/media/airbnb.f2354d6e.csv";